import script from "./instructionActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./instructionActivity.vue?vue&type=script&setup=true&lang=js"

import "./instructionActivity.vue?vue&type=style&index=0&id=ba0b35e8&lang=scss"

const __exports__ = script;

export default __exports__